export const pageTitle = (title) => {
  return ( document.title = title + " - Stable Records Studio | Nahrávací studio Praha");
}